(() => {
  'use strict';

  const PLACEMENT_SELECTOR = 'klarna-placement';
  const ACTION_SELECTOR = 'a, button, [role="link"], [role="button"]';
  const ACTION_TEXT = /purchase\s*power|check\s*purchase|learn\s*more/i;

  const getActionFromRoot = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function') return null;
    const actions = Array.from(root.querySelectorAll(ACTION_SELECTOR));
    return actions.find((node) => ACTION_TEXT.test((node.textContent || '').trim())) || actions.find((node) => node.tagName === 'A' && node.href) || null;
  };

  const getKlarnaAction = (placement) => {
    return getActionFromRoot(placement.shadowRoot) || getActionFromRoot(placement);
  };

  const enhancePlacement = (placement) => {
    if (!placement || placement.dataset.hikWholeClick === 'true') return;
    placement.dataset.hikWholeClick = 'true';
    placement.style.cursor = 'pointer';

    placement.addEventListener('click', (event) => {
      if (placement.dataset.hikForwarding === 'true') return;

      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const clickedNativeAction = path.some((node) => {
        if (!node || node === placement || typeof node.matches !== 'function') return false;
        return node.matches(ACTION_SELECTOR);
      });

      if (clickedNativeAction) return;

      const action = getKlarnaAction(placement);
      if (!action) return;

      event.preventDefault();
      placement.dataset.hikForwarding = 'true';
      try {
        action.click();
      } finally {
        window.setTimeout(() => {
          delete placement.dataset.hikForwarding;
        }, 0);
      }
    });
  };

  const scan = (scope = document) => {
    if (scope.matches?.(PLACEMENT_SELECTOR)) enhancePlacement(scope);
    scope.querySelectorAll?.(PLACEMENT_SELECTOR).forEach(enhancePlacement);
  };

  const start = () => {
    scan();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
